// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isQueryBuilderCreditsResult = objectOf({
  mtd_sql_credits_used: number,
  mtd_sql_credits_available: number,
});
